import PropTypes from 'prop-types'

const CheckOne = ({
  width = '24',
  height = '24',
  className = '',
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 49 48"
    fill="none"
    className={className}
    {...{ ...props }}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="check-one">
      <path
        id="Vector"
        d="M24.5 44C30.0228 44 35.0228 41.7614 38.6421 38.1421C42.2614 34.5228 44.5 29.5228 44.5 24C44.5 18.4772 42.2614 13.4772 38.6421 9.85786C35.0228 6.23858 30.0228 4 24.5 4C18.9772 4 13.9772 6.23858 10.3579 9.85786C6.73858 13.4772 4.5 18.4772 4.5 24C4.5 29.5228 6.73858 34.5228 10.3579 38.1421C13.9772 41.7614 18.9772 44 24.5 44Z"
        fill="white"
        stroke="#0D8653"
        strokeWidth="4"
        strokeLinejoin="round"
      />
      <path
        id="Vector_2"
        d="M16.5 24L22.5 30L34.5 18"
        stroke="#0D8653"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
)

CheckOne.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  className: PropTypes.string,
}

CheckOne.defaultProps = {
  width: '24',
  height: '24',
  className: '',
}

export default CheckOne
